import { render, staticRenderFns } from "./App.vue?vue&type=template&id=0bcff689&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "alertifyjs/build/css/alertify.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "alertifyjs/build/css/themes/default.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports